export const errorMessages = new Map([
  // AUTH
  ['USER_UNAUTHORIZED_ERROR', 'Неправильный логин или пароль'],
  ['ACCESS_TOKEN_NOT_VALID_ERROR', 'Ошибка авторизации'],
  ['ACCESS_TOKEN_NOT_PARSE_ERROR', 'Ошибка авторизации'],
  ['REFRESH_TOKEN_NOT_FOUND_DATABASE_ERROR', 'Ошибка авторизации'],

  // токен стух (показывать ошибку только если мы отправили запрос на обновление токена, а все равно пришла ошибка)
  ['AUTH_JWT_ERROR', 'Сессия истекла'],
  // юзер пытается попасть на админскую страницу, к которой у него нет доступа
  ['USER_ACCESS_DENIED', 'Ошибка доступа'],

  //CORE
  ['INTEGR_CALENDAR_INTEGRATION_ERROR', 'При синхронизации календарей произошла ошибка'],

  // интеграция календаря
  ['INTEGR_SERVICE_CONNECTION_ERROR', 'При синхронизации календарей произошла ошибка'],
  ['INTEGR_DOWNLOAD_CALENDAR_ERROR', 'Ошибка загрузки календаря'],
  ['INTEGR_USER_NOT_FOUND_IN_DB_ERROR', 'Пользователь не найден'],
  ['INTEGR_ICAL_PARSER_ERROR', 'Ошибка чтения календаря, проверьте ссылку'],
  ['INTEGR_CALENDAR_NOT_FOUND', 'Подключенный календарь не найден'],
  ['INTEGR_PROVIDE_WRONG_DATA_ERROR', 'Указаны некорректные данные'],
  ['INTEGR_CALENDAR_ALREADY_EXIST', 'Календарь уже подключен'],
  ['CALENDAR_PROVIDER_NOT_VALID', 'Указан неверный провайдер календаря'],
  ['INTEGR_INVALID_DATA_ERROR', "Введены некорректные данные"],
  ['MCS_ALREADY_SET_STATUS_ERROR', 'Вы уже ответили на данное приглашение, изменить выбор нельзя'],
  // встречи
  ['MS_MEETINGID_ERROR', 'Такой встречи не существует!'],
  ['MS_CANNOT_FIND_ENTITY_ERROR', 'Встреча не найдена'],
  ['MS_ALREADY_DELETED_MEETING_ERROR', 'Встреча уже удалена'],
  ['MS_FORBIDDEN_DELETE_YOURSELF_FROM_PARTICIPANTS_ERROR', 'Вы не можете удалить инициатора встречи из списка участников'],
  ['MS_ALREADY_IN_DATABASE', 'Такая встреча уже существует'],
  ['MS_INCORRECT_EMAIL', 'Такой встречи не существует!'],
  ['MS_MEETING_CONFIRMATION_NOT_FOUND_DATABASE', 'Ошибка получения статуса участника'],

  // напоминания
  ['NS_CANNOT_FIND_ENTITY_ERROR', 'Такой встречи не существует!'],
  ['NS_REMINDER_TIMESTAMP_SHOULD_BE_POSITIVE', 'Указано некорректное время напоминания'],
  ['NS_REMINDER_TIMESTAMP_OUT_OF_RANGE', 'Время напоминания не может быть больше максимального значения'],
  ['NS_MAX_COUNT_OF_REMINDERS_REACHED', 'Достигнуто максимальное количество уведомлений'],
  ['NS_REMINDER_TIMESTAMP_ALREADY_EXISTS', 'Такое время напоминания уже существует'],
  ['NS_CANNOT_DELETE_START_WORKDAY_REMINDER', 'Вы не можете удалить напоминание в начале рабочего дня'],

  // профиль
  ['EMAIL_ALREADY_IN_DATABASE', 'Почта уже подключена'],
  ['EMAIL_ALREADY_VERIFIED', 'Почта уже подтверждена'],
  ['EMAIL_INCORRECT_VALUE', 'Неверный формат почты'],
  ['EMAIL_NOT_FOUND', 'Почта не найдена'],
  ['EMAIL_VERIFICATION_RESEND_TIMEOUT', 'Время ожидания между повторными отправками составляет ~ мин.'],
  ['USER_NOT_FOUND_DATABASE', 'Профиль не найден'],
  //версия
  ['VS_CANNOT_FIND_ENTITY_ERROR', 'Номер версии не найден'],

  // Подтверждение встреч
  ['MS_USER_CAN_NOT_MODIFY_CONFIRMATION', 'Нет доступа для ответа на предложения времени'],
  ['MS_CONFIRMATION_TIME_EXPIRED', 'Предложенное время уже прошло'],

  //КФЗ
  ['MS_CONFERENCE_ROOM_BOOKED', 'КФЗ уже забронирован на указанное время'],
  ['MS_CONFERENCE_ROOM_BOOKING_TIME_EXCEEDED', 'Превышен лимит бронирования КФЗ в ~ дней'],
  ['MS_CONFERENCE_ROOM_ENDLESS_BOOKING', 'Нельзя создавать бесконечную циклическую встечу в КФЗ'],

  //Базовые ошибки
  ['CANNOT_FIND_ENTITY_ERROR', 'Не найдена запись в БД'],
  ['INTERNAL_SERVER_ERROR', 'Внутренняя ошибка сервера'],
]);
